import React from 'react';

interface Props {
  size?: number;
}

/**
 * CRPD-7274 — the Details affordance on a tier row that holds NO commentary: an empty speech
 * bubble. Its counterpart, `CommentaryNoteSvg`, marks a tier that does.
 *
 * Paints with `currentColor` so the row's button owns the colour and its hover, which is what
 * lets one rule cover both the stroked and the filled glyph.
 */
export const CommentarySvg: React.FC<Props> = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H15.8333C16.7538 2.5 17.5 3.24619 17.5 4.16667V12.5C17.5 13.4205 16.7538 14.1667 15.8333 14.1667H7.15533C6.71331 14.1667 6.28938 14.3423 5.97682 14.6548L3.92259 16.709C3.66022 16.9714 3.21143 16.7856 3.21143 16.4145V14.1667C2.81802 14.1667 2.5 13.7318 2.5 13.3333V4.16667Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path d="M5.83398 6.25H14.1673" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path d="M5.83398 9.16669H11.6673" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);
